import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import ReactDOMServer from "react-dom/server";
import { toast } from "sonner";

import footerImg from "@/assets/images/footerImg.png";
import defaultLogo from "@/assets/images/headerImg.png";
import { WasteFormat } from "@/interfaces/wastetype.interface";

export const PrintFormat = ({
  letterHead,
}: {
  letterHead: WasteFormat;
}): JSX.Element => {
  return (
    <div>
      {letterHead?.headerActive && (
        <div
          style={{
            width: "100%",
            textAlign: "center",
            position: "absolute",
            top: "0",
            left: "0",
          }}
        >
          <img
            src={letterHead?.headerImage || defaultLogo}
            alt='header'
            style={{
              opacity: letterHead?.headerOpacity,
              width: "100%",
              height: "140px",
              objectFit: "fill",
            }}
          />
        </div>
      )}

      <div style={{ position: "absolute", bottom: "0", width: "100%" }}>
        {letterHead?.footerActive && (
          <img
            src={letterHead?.footerImage || footerImg}
            alt='footer'
            style={{
              opacity: letterHead?.footerOpacity,
              width: "100%",
              height: "140px",
              objectFit: "fill",
            }}
          />
        )}
      </div>
    </div>
  );
};

export const createBase64Data = async ({
  componentRef,
  letterHead,
}: {
  componentRef: React.RefObject<HTMLDivElement>;
  letterHead: WasteFormat;
}): Promise<string> => {
  try {
    if (componentRef.current) {
      const template = ReactDOMServer.renderToString(
        <PrintFormat letterHead={letterHead} />,
      );

      const dataUri = await drawDOM(
        // pdfExportComponent?.current?.rootElForPDF,
        componentRef.current,
        {
          paperSize: "A4",
          scale: 0.7,
          forcePageBreak: ".page-break",
          repeatHeaders: true,
          keepTogether: "section",
          margin: {
            top: 95,
            bottom: 95,
          },

          template: () => {
            return template;
          },
        },
      )
        .then((group) => {
          return exportPDF(group);
        })
        .then((dataUri) => {
          return dataUri;
        });

      return dataUri;
    }
  } catch (error) {
    toast.error("Error while creating PDF");
  }

  return "";
};
